import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../stores/store";
import { setToast } from "../../stores/toast/toastslice";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Header,
  ModalWrapper,
} from "../../components/style/modalStyleLarge";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import CustomButton from "../../components/common-components/CustomButton";
import { ActiveInactiveIcon, CrossIcon } from "../../assets/Icon/ModalIcon";
import {
  activeInactiveClient,
  ClientDetailData,
  getClientList,
} from "../../stores/clients";
import { styled } from "@mui/material/styles";
import UploadFileFieldNew from "../../components/common-components/UploadFileFieldNew";
import ConfirmModal from "../../components/common-components/ConfirmModal";
import { ScannerIcon } from "../../assets/Icon/dashboredIcon";
import * as Yup from "yup";
import { useFormik } from "formik";
import { uploadDocs } from "../../stores/orders";
import UploadMultipleFile from "../../components/common-components/UploadMultipleFile";
import UploadFileFieldSingleDoc from "../../components/common-components/UploadVerifiedDocSingle";

interface ModalPropType {
  open: boolean;
  handleClose: () => void;
  id: any;
  onSuccess?: () => void;
  status?: number;
  productId?: number;
}

export default function DocumentUploadModal({
  open,
  handleClose,
  id,
  onSuccess,
  status,
  productId,
}: ModalPropType) {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  // Seal prompt, mirroring the user flow: the backend stops ahead of filing the
  // document when it carries no official seal, and the reviewer decides.
  const [sealNoticeOpen, setSealNoticeOpen] = useState(false);
  const [sealAcknowledged, setSealAcknowledged] = useState(false);
  // Proceed sets this; an effect does the resubmit once sealAcknowledged has
  // actually landed in state. Calling handleSubmit from the handler (or via
  // setTimeout) can read the previous value and submit without consent.
  const [resubmitAfterConsent, setResubmitAfterConsent] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [filePreview, setFilePreview] = useState<string | null>("");
  const [fileUploads, setFileUploads] = useState<{
    [key: string]: File | null | string;
  }>({
    company_formation_file: "",
  });
  const [filePreviews, setFilePreviews] = useState<string[]>([]);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;

    formik.setFieldValue("company_formation_file", file);
    // A different document has to be judged on its own seal, so consent given
    // for the previous one cannot carry over.
    setSealAcknowledged(false);

    if (file) {
      const previewURL = URL.createObjectURL(file);
      setFilePreview(previewURL);
    } else {
      setFilePreview("");
    }
  };

  const numericProductId = Number(productId);
  const numericStatus = Number(status);

  const getFileType = (): number | null => {
    if (numericProductId === 1) return 2;
    if (numericProductId === 2 && numericStatus === 2) return 0;
    if (numericProductId === 2 && numericStatus === 6) return 1;
    return null;
  };

  const fileType = getFileType();
  // const formik = useFormik({
  //   initialValues: {
  //     file: null,
  //     files: [],
  //   },
  //   validationSchema: Yup.object({
  //     file: Yup.mixed()
  //       .required("Document is required")
  //       .test("fileType", "Unsupported File Format", (value) => {
  //         if (!value) return false;
  //         const file = value as File;
  //         const supportedFormats = [
  //           "application/pdf",
  //           "image/jpeg",
  //           "image/png",
  //         ];
  //         return supportedFormats.includes(file.type);
  //       }),
  //     files: Yup.array()
  //       .min(1, "At least one file is required")
  //       .required("Please upload at least one document"),
  //   }),
  //   // onSubmit: async (values) => {
  //   //   if (!values.file) {
  //   //     dispatch(
  //   //       setToast({ type: "error", message: "Please upload a valid file" })
  //   //     );
  //   //     return;
  //   //   }

  //   //   const file = values.file as File;

  //   //   const payload = {
  //   //     order_id: Number(id),
  //   //     file_type: Number(fileType),
  //   //     file: file,
  //   //   };

  //   //   try {
  //   //     setLoading(true);
  //   //     const res = await dispatch(uploadDocs(payload)).unwrap();

  //   //     if (res?.status === 1) {
  //   //       dispatch(setToast({ type: "success", message: res.message }));

  //   //     } else {
  //   //       dispatch(setToast({ type: "error", message: res.message }));
  //   //     }
  //   //     if (onSuccess) {
  //   //       onSuccess();
  //   //     }
  //   //     handleClose();
  //   //   } catch (error: any) {
  //   //     dispatch(
  //   //       setToast({
  //   //         type: "error",
  //   //         message: error.message || "Something went wrong",
  //   //       })
  //   //     );
  //   //   } finally {
  //   //     setLoading(false);
  //   //   }
  //   // },

  //   onSubmit: async (values) => {
  //     const uploads = [];

  //     setLoading(true);

  //     const fileType = getFileType();

  //     if (values.file  && numericProductId !== 1) {
  //       uploads.push({
  //         order_id: Number(id),
  //         file_type: Number(fileType),
  //         file: values.file as File,
  //       });
  //     }

  //     if (values.files && values.files.length > 0) {
  //       for (const file of values.files) {
  //         uploads.push({
  //           order_id: Number(id),
  //           file_type: Number(fileType),
  //           file: file as File,
  //         });
  //       }
  //     }

  //     if (uploads.length === 0) {
  //       dispatch(
  //         setToast({ type: "error", message: "Please upload a valid file" })
  //       );
  //       setLoading(false);
  //       return;
  //     }

  //     try {
  //       for (const upload of uploads) {
  //         const res = await dispatch(uploadDocs(upload)).unwrap();
  //         if (res?.status !== 1) {
  //           throw new Error(res?.message || "Upload failed");
  //         }
  //       }

  //       dispatch(
  //         setToast({ type: "success", message: "Files uploaded successfully" })
  //       );
  //       if (onSuccess) onSuccess();
  //       handleClose();
  //     } catch (error: any) {
  //       dispatch(
  //         setToast({
  //           type: "error",
  //           message: error.message || "Something went wrong during upload",
  //         })
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  // });
  const getValidationSchema = () => {
    const isSingleFileRequired = numericProductId !== 1;
    return Yup.object().shape({
      company_formation_file: isSingleFileRequired
        ? Yup.mixed()
            .required("Document is required")
            .test("fileType", "Unsupported File Format", (value: any) => {
              if (!value) return false;
              return ["application/pdf", "image/jpeg", "image/png"].includes(
                value.type,
              );
            })
        : Yup.mixed().notRequired(),
    });
  };

  const validationSchemaSingle = () => {
    const isSingleFileRequired =
      numericProductId === 1 || (numericProductId === 2 && fileType === 1);

    return Yup.object().shape({
      files: isSingleFileRequired
        ? Yup.mixed().required("Document is required")
        : // .test(
          //   "fileType",
          //   "Unsupported File Format",
          //   (value: any) => {
          //     // Only run this test if a file is provided
          //     if (!value) return true; // skip this test if no file, let 'required' handle it
          //     return ["application/pdf", "image/jpeg", "image/png"].includes(
          //       value.type
          //     );
          //   }
          // )
          Yup.mixed().notRequired(),
    });
  };

  const formik = useFormik({
    initialValues: {
      company_formation_file: null,
      files: fileType === 0 ? [] : null,
    },
    validationSchema:
      fileType === 0 ? getValidationSchema() : validationSchemaSingle,

    onSubmit: async (values) => {
      setLoading(true);
      const fileType = getFileType();
      let payload: {
        order_id: number;
        file_type: number;
        seal_acknowledged?: boolean;
        company_formation_file?: File;
        files?: File[];
      } = {
        order_id: Number(id),
        file_type: Number(fileType),
        seal_acknowledged: sealAcknowledged || undefined,
      };

      if (values.company_formation_file) {
        payload.company_formation_file = values.company_formation_file as File;
      }

      if (values.files) {
        payload.files = values.files as File[];
      }

      try {
        const res = await dispatch<any>(uploadDocs(payload)).unwrap();

        // Nothing was filed when the gate fires, so dismissing is safe.
        if (res?.needs_seal_confirmation) {
          setLoading(false);
          setSealNoticeOpen(true);
          return;
        }

        if (res?.status !== 1) {
          throw new Error(res?.message || "Upload failed");
        }
        // The client asked that admin also see whether the formation document
        // carries an official seal. Formation docs are file_type 0, and the
        // backend reports the finding on the stored extraction.
        //
        // Deliberately NOT an error: a plain filed copy legitimately has no
        // seal, and an embossed seal often does not survive a scan. And the
        // flag is tri-state -- null means the check could not run, which must
        // not be reported as "no seal".
        const seal = res?.data?.llc_extracted_data?.seal_present ?? null;
        let sealNote = "";
        if (Number(fileType) === 0) {
          if (seal === true) {
            const pages = res?.data?.llc_extracted_data?.seal_pages ?? [];
            sealNote = pages.length
              ? ` An official seal was detected on page ${pages.join(", ")}.`
              : " An official seal was detected.";
          } else if (seal === false) {
            sealNote = " No official seal was detected on this document.";
          }
        }

        dispatch<any>(
          setToast({
            type: "success",
            message: `Files uploaded successfully.${sealNote}`,
          }),
        );
        if (onSuccess) onSuccess();
        handleClose();
      } catch (error: any) {
        dispatch<any>(
          setToast({
            type: "error",
            message:
              error?.data?.message ||
              error?.message ||
              "Something went wrong during upload",
          }),
        );
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (resubmitAfterConsent && sealAcknowledged) {
      setResubmitAfterConsent(false);
      formik.handleSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resubmitAfterConsent, sealAcknowledged]);

  return (
    <>
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="status-modal-title"
    >
      <ModalWrapper
        sx={{
          width: isMobile ? "90%" : "45%",
          maxWidth: "498px",
          minHeight: "350px",
          maxHeight: "602px",
          margin: "auto",
          overflow: "hidden",
          paddingBottom: "24px !important", // <-- add this
          p: isMobile ? 2 : 3,
        }}
      >
        <CloseButtonWrapper>
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>

        <form onSubmit={formik.handleSubmit}>
          <ScrollableWrapper>
            <Content
              sx={{ textAlign: "center", padding: "0 20px", margin: "20px" }}
            >
              {numericProductId === 2 && fileType === 0 && (
                <>
                  <UploadFileFieldNew
                    title={"Upload Company Formation Document"}
                    icon={<ScannerIcon />}
                    name="company_formation_file"
                    formik={formik}
                    handleFileChange={handleFileChange}
                    setFilePreview={setFilePreview}
                    filePreview={filePreview}
                    accept="application/pdf, image/jpeg, image/png"
                  />

                  <UploadMultipleFile
                    title={"Upload Others Documents"}
                    name="files"
                    icon={<ScannerIcon />}
                    formik={formik}
                    filePreviews={filePreviews}
                    setFilePreviews={setFilePreviews}
                    accept="application/pdf,image/jpeg,image/png"
                    disabled={loading}
                  />
                </>
              )}

              {numericProductId === 1 && (
                <UploadFileFieldSingleDoc
                  title={"Upload ITIN Document"}
                  icon={<ScannerIcon />}
                  name="files"
                  formik={formik}
                  handleFileChange={handleFileChange}
                  setFilePreview={setFilePreview}
                  filePreview={filePreview}
                  accept="application/pdf, image/jpeg, image/png"
                />
              )}

              {numericProductId === 2 && fileType === 1 && (
                <UploadFileFieldSingleDoc
                  title={"Upload EIN Document"}
                  icon={<ScannerIcon />}
                  name="files"
                  formik={formik}
                  handleFileChange={handleFileChange}
                  setFilePreview={setFilePreview}
                  filePreview={filePreview}
                  accept="application/pdf, image/jpeg, image/png"
                />
              )}
            </Content>
          </ScrollableWrapper>
          <ButtonWrapper
            sx={{
              display: "flex",
              justifyContent: isMobile ? "center" : "space-between",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "10px" : "2px",
              marginBottom: "15px !important",
              marginTop: "5px !important",
            }}
          >
            <CustomButton
              btnTitle="No"
              handleClick={handleClose}
              disabled={loading}
              minwidth={isMobile ? "100%" : "45%"}
              bgColor="#FFF"
              textColor="#2977CC"
              borderColor={loading ? "transparent" : "#2977CC"}
              borderWidth={2.3}
              sx={{ fontSize: "18px" }}
            />
            <CustomButton
              btnTitle={"Yes"}
              type="submit"
              disabled={loading}
              loading={loading}
              minwidth={isMobile ? "100%" : "45%"}
              borderColor={loading ? "transparent" : "#2977CC"}
              sx={{ fontSize: "18px" }}
            />
          </ButtonWrapper>
        </form>
      </ModalWrapper>
    </Modal>

    {/* Same prompt the applicant sees. Proceeding re-submits with consent, since
        the gate returned before the document was filed. */}
    <ConfirmModal
      open={sealNoticeOpen}
      title="No official stamp found"
      message="No official stamp was found on the business documents you uploaded; if you are certain that an official stamp is present, you may proceed."
      confirmLabel="Proceed"
      cancelLabel="Re-upload"
      loading={loading}
      onConfirm={() => {
        setSealNoticeOpen(false);
        setSealAcknowledged(true);
        setResubmitAfterConsent(true);
      }}
      onCancel={() => setSealNoticeOpen(false)}
    />
    </>
  );
}
const ScrollableWrapper = styled(Box)({
  maxHeight: "500px",
  overflowY: "auto",
  paddingBottom: "15px !important",
});
